export enum WindowTypeEnum {
  Welcome = "welcome",
  Desktop = "desktop",
  DeviceStory = "device-story",
  VisitorStories = "visitor-stories",
  SubmitStory = "submit-story",
}
